import { GridContainer } from "@amzn/stencil-react-components/layout";
import { Col } from "@amzn/stencil-react-components/layout";
import { PaginationVariant } from "@amzn/stencil-react-components/pagination";
import { Text } from "@amzn/stencil-react-components/text";
import { Pagination } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import { getString } from "common/uistringlabels/uiStringUtils";
import { AiForMeNews } from "lib/models/aiformenews-models";
import React, { FC, useState } from "react";
import { AiNewsCard } from "view/Page/AiForMe/components/AiNewsCard";

export interface AiNewsSectionProps {
  news: AiForMeNews[];
}

const NEWS_PER_PAGE = 3;
const FIRST_PAGE = 1;

export const AiNewsSection: FC<AiNewsSectionProps> = ({ news }) => {
  const [currentPage, setCurrentPage] = useState<number>(FIRST_PAGE);
  const totalPages = Math.ceil(news.length / NEWS_PER_PAGE);
  const startIndex = (currentPage - 1) * NEWS_PER_PAGE;
  const displayedNews = news.slice(startIndex, startIndex + NEWS_PER_PAGE);

  return (
    <Col rowGap={24} alignItems="center" data-testid="ai-news-section">
      <Text fontSize="T400" fontWeight="bold" data-testid="ai-news-heading">
        {getString("aiForMe.landingPage.aiNewsSection.sectionTitle")}
      </Text>

      <GridContainer>
        {displayedNews.map((item, index) => (
          <AiNewsCard key={item.taxonomyId} item={item} index={startIndex + index} gridSpan={{ lg: 4, md: 4 }} />
        ))}
      </GridContainer>
      {totalPages > 1 && (
        <Pagination
          numberOfPages={totalPages}
          selectedPage={currentPage}
          onPageSelect={setCurrentPage}
          variant={PaginationVariant.Dotted}
          touchpoint={"aiforme-new-pagination"}
        />
      )}
    </Col>
  );
};
